import packegeJson from "../../../package.json";
import { getVersionFromLocalStorage, setVersionToLocalStorage } from "../../services/localStorage.service";
// import { UserNotification } from "../../interfaces";

/** seting action types */
// export const actionTypes = {
//   SAVE_MAINTENANCE: "SAVE_MAINTENANCE",
//   SAVE_VERSION: "SAVE_VERSION",
//   SAVE_NOTIFICATIONS: "SAVE_NOTIFICATIONS",
//   SAVE_NOTIFICATIONS_UNREAD_COUNT: "SAVE_NOTIFICATIONS_UNREAD_COUNT"
// };

/*
 * Action creators for login
 */

// export const saveMaintenanceMode = (data: {mode: MaintenanceMode, scheduledDate?: Date}) => (dispatch) => {
//   dispatch({
//     type: actionTypes.SAVE_MAINTENANCE,
//     data: data
//   })
// }

/**
 * Gets the current application version.
 * First checks localStorage for stored version, falls back to package.json version.
 * On first load, initializes localStorage with package.json version.
 */
export const getPackageJsonVersion = (): string => {
  const storedVersion = getVersionFromLocalStorage();
  const packageVersion = packegeJson?.version;
  
  if (storedVersion) {
    return storedVersion;
  }
  
  // Initialize localStorage with package.json version on first load
  setVersionToLocalStorage(packageVersion);
  return packageVersion;
};

/**
 * Updates the stored version in localStorage.
 * This should be called when the server version is confirmed (e.g., after page reload).
 */
export const updateStoredVersion = (version: string): void => {
  setVersionToLocalStorage(version);
};

// export const updateVersion = (data: string) => (dispatch) => {
//   const isVersionChanged = !equalsIgnoreCase(data, packegeJson?.version);
//   dispatch({
//     type: actionTypes.SAVE_VERSION,
//     data: isVersionChanged
//   })
// }

// export const saveNotifications = (data: UserNotification[]) => (dispatch) => {
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS,
//     data: data
//   })
// }

// export const saveSocketNotification = (data: UserNotification) => (dispatch, getState) => {
//   const notifications = getState().system.notifications;
//   const count = getState().system.notificationsUnreadCount;
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS,
//     data: [data, ...notifications]
//   })
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS_UNREAD_COUNT,
//     data: count + 1
//   })
// }

// export const saveNotificationsCount = (data: number) => (dispatch) => {
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS_UNREAD_COUNT,
//     data: data
//   })
// }